import React from 'react';
import {
  Grid,
  TextField,
  Box,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
  Typography,
} from '@mui/material';
const ApprovalForm = ({ apprDoc, formik }) => {
  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: 2,
        px: 2,
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          py: 1,
        }}
      >
        <Typography variant="subtitle2" component="div">
          결재 타입:{apprDoc?.docyTyp} | 결재 단계:{apprDoc?.docuStep} | 현재
          결재자:{apprDoc?.docuUsrNm}
          {apprDoc?.docuUsrGradeNm}
        </Typography>
      </Box>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={3}>
          <FormControl component="fieldset" sx={{ ml: 2 }}>
            <FormLabel component="legend">결재 여부</FormLabel>
            <RadioGroup
              row
              aria-label="docuYn"
              name="row-radio-buttons-group"
              value={formik.values.docuYn || 'Y'}
              onChange={(event) =>
                formik.setFieldValue('docuYn', event.target.value)
              }
            >
              <FormControlLabel value="Y" control={<Radio />} label="승인" />
              <FormControlLabel value="N" control={<Radio />} label="비승인" />
              {formik.touched.docuYn && Boolean(formik.errors.docuYn) && (
                <FormHelperText>{formik.errors.docuYn}</FormHelperText>
              )}
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={7}>
          <TextField
            required
            margin="normal"
            variant="standard"
            fullWidth
            id="docuTxt"
            name="docuTxt"
            label="참고사항"
            value={formik.values.docuTxt}
            onChange={formik.handleChange}
            error={formik.touched.docuTxt && Boolean(formik.errors.docuTxt)}
            helperText={formik.touched.docuTxt && formik.errors.docuTxt}
          />
        </Grid>
        <Grid item xs={1} textAlign="center">
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            결재
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApprovalForm;
